module.exports = __webpack_public_path__ + "static/img/search-bg.1ce340a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search-bg.png
// module id = kFu3
// module chunks = 7